










































































































































































































































import { Component, Vue, Ref, Watch } from "vue-property-decorator";
import User from "@/data/models/User";
import { BranchFilter } from "@/data/models/BranchFilter";
import {
  getLogoFile,
  getClientInfo,
  getProjectManagement,
  findBranch,
  hasClientEnabledStrictBranchFilters,
  loadClient,
  getMemberClientIds,
  getClientsByIds,
  getMemberClientsInformationOfGroup,
} from "@/data/repository/ClientRepository";
import { formatLocationInfo } from "@/utils/LocalisationHelper";
import { observePanelsOfClient, observePanelsOfMemberClients } from "@/data/repository/PanelRepository";

import {
  observeRecentlyFinishedDryingProjects,
  observeRunningDryingProjects,
  observeRecentlyFinishedLeakDetectionProjects,
  observeRunningLeakDetectionProjects,
} from "@/data/repository/ProjectOverviewRepository";

import { ProjectsModule } from "@/store/modules/ProjectsModule";
import { Panel } from "@/data/models/Panel";
import { UserModule } from "@/store/modules/UserModule";
import { endViewAs, getViewAsUser, startViewAs } from "@/utils/ViewAs";
import { clearViewAsSelection } from "@/utils/ViewAsSession";
import { getUserDisplayName } from "@/utils/UserUtils";
import { getSelectableTargetUsers } from "@/utils/TargetUserSelection";

import FirestoreImageComponent from "@/components/common/FirestoreImage.vue";

import {
  getActiveUser,
  getDefaultBranchFilterOfUser,
} from "@/data/repository/UserRepository";

import CockpitCardComponent from "@/components/overview/CockpitCard.vue";
import { UserLookup } from "@/data/models/UserLookup";
import { CockpitEntryInfo } from "./CockpitEntryInfoItem.vue";
import { ComBox } from "@/data/models/ComBox";
import { observeComBoxesOfClient, observeComBoxesOfMemberClients } from "@/data/repository/ComBoxRepository";
import UserPickerDialog from "@/components/common/UserPickerDialog.vue";
import SharedEmailAddressOptionsDialogComponent from "@/components/login/SharedEmailAddressOptionsDialog.vue";
import BranchFilterSelectorComponent from "@/components/common/BranchFilterSelector.vue";
import { getBranchName } from "@/data/models/Branch";
import CompanyHeaderComponent from "@/components/common/CompanyHeader.vue";
import MessagesCockpitCardComponent from "./MessagesCockpitCard.vue";
import {
  COLOR_COCKPIT_EXTRAS,
  COLOR_COCKPIT_EXTRAS_DARK,
  COLOR_COCKPIT_MANAGEMENT,
  COLOR_COCKPIT_MANAGEMENT_DARK,
  COLOR_COCKPIT_MY_TASKS,
  COLOR_COCKPIT_MY_TASKS_DARK,
  COLOR_SELECTED_NON_DEFAULT_TOOLBAR_FILTER_BACKGROUND,
} from "@/utils/colors";
import { themed } from "@/utils/Theme";
import { HyDryEventMessagesFilter } from "@/utils/HyDryEventMessagesFilter";
import { observeMailboxesOfUser } from "@/data/repository/MailboxRepository";
import { Mailbox } from "@/data/models/Mailbox";
import { MailboxFilter } from "@/utils/MailboxFilter";
import {
  createCockpitProjectInfo,
  CockpitProjectsInfo,
} from "@/utils/CockpitProjectsInfoCreator";
import { doesClientHaveApp, getClientId } from "@/data/repository/ClientRepository";
import {
  calculateHyDryDeviceItems,
  getHyDryDeviceCount,
} from "@/utils/CockpitHyDryDevicesInfoCreator";
import { DeviceFilter } from "@/data/models/DeviceFilter";
import { getSharedEmailAddressInfo } from "@/data/repository/SharedEmailAddressRepository";
import { SharedEmailAddressUserInfo } from "@/data/models/SharedEmailAddressInfo";
import { LoginResult } from "../login/LoginTypes";
import { isClientSignInBlocked } from "@/utils/SignInRefusal";
import { observeDeviceOverviews } from "@/data/repository/AllDevicesRepository";
import { calculateAllDevicesItems } from "@/utils/CockpitAllDevicesInfoCreater";
import { observeClientPanels } from "@/data/repository/ClientPanelRepository";
import ClientPanel from "@/data/models/ClientPanel";
import { filterRetainedDevices, isDeviceDeleted } from "@/utils/DeviceManagementUtils";
import { DeviceOverview } from "@/data/models/DeviceOverview";
import { 
  allHyDryDevicesAccess, 
  switchTargetUserAccess, 
  viewHyDryDevicesOfMemberAccess,
  relevantProjectsTileAccess,
  allProjectsTileAccess,
  allDevicesTileAccess,
  createProjectAccess,
  myProjectsTileAccess,
  myAppointmentsTileAccess,
  myHyDryDevicesTileAccess,
  projectOraganisationTileAccess,
  appointmentManagementTileAccess,
  myMessagesTileAccess,
  viewClientSelectorAccess,
  createAppointmentAccess,
} from "@/permissions/UserPermissions";
import router from "@/router/router";
import { RoleSettingsModule } from "@/store/modules/RoleSettingsModule";
import { getHyDryMessagesSettings } from "@/data/repository/SettingsRepository";
import { FinishedProjectsSettingsModule } from "@/store/modules/FinishedProjectsSettingsModule";
import { getProjectSettingsV2 } from "@/data/models/Settings";
import { ProjectManagementSettingsModule } from "@/store/modules/ProjectManagementSettingsModule";
import ClientOptionsDialogComponent from "../login/ClientOptionsDialog.vue";
import { switchClientsAccess } from "@/permissions/ClientPermissions";
import { ClientModule } from "@/store/modules/ClientModule";
import SharedUserOfGroupOptionsDialogComponent from "../login/SharedUserOfGroupDialog.vue";
import AppBarLogoComponent from "@/components/common/AppBarLogo.vue";
import { getStoredBranchFilterId } from "@/utils/BranchFilterStorage";

@Component({
  name: "CockpitComponent",
  components: {
    "app-bar-logo": AppBarLogoComponent,
    "messages-cockpit-card": MessagesCockpitCardComponent,
    "company-header": CompanyHeaderComponent,
    "firestore-image": FirestoreImageComponent,
    "cockpit-card": CockpitCardComponent,
    "branch-filter-selector": BranchFilterSelectorComponent,
    "user-picker": UserPickerDialog,
    "shared-email-address-options": SharedEmailAddressOptionsDialogComponent,
    "client-options-dialog": ClientOptionsDialogComponent,
    "shared-user-of-group-options-dialog": SharedUserOfGroupOptionsDialogComponent,
  },
})
export default class CockpitComponent extends Vue {
  @Ref("userPickerDialog")
  userPickerDialog!: UserPickerDialog;
  
  @Ref("sharedEmailAddressOptions")
  sharedEmailAddressOptions!: SharedEmailAddressOptionsDialogComponent;

  @Ref("clientOptionsDialog")
  clientOptionsDialog!: ClientOptionsDialogComponent;

  @Ref("sharedUserOfGroupOptionsDialog")
  sharedUserOfGroupOptionsDialog!: SharedUserOfGroupOptionsDialogComponent;

  logo = getLogoFile();

  componentActive = true;

  get colorManagement() {
    return themed(COLOR_COCKPIT_MANAGEMENT, COLOR_COCKPIT_MANAGEMENT_DARK);
  }

  get colorMyTasks() {
    return themed(COLOR_COCKPIT_MY_TASKS, COLOR_COCKPIT_MY_TASKS_DARK);
  }

  get colorExtras() {
    return themed(COLOR_COCKPIT_EXTRAS, COLOR_COCKPIT_EXTRAS_DARK);
  }

  hideSwitchSharedUser = true;

  clientInfo = getClientInfo();

  panels: Array<Panel> = [];
  comBoxes: Array<ComBox> = [];

  iresDeviceUpdateDebouncer: NodeJS.Timeout | null = null;
  pendingIresDeviceUpdates: Array<() => void> = [];

  subscriptions: Array<() => void> = [];
  targetUserSubscriptions: Array<() => void> = [];

  // Kept apart from the above so the device observers survive a mailbox re-subscribe.
  iresDeviceSubscriptions: Array<() => void> = [];
  observedIresDeviceScopeKey: string | null = null;

  selectedBranchFilter = getDefaultBranchFilterOfUser();
  mailboxes: Mailbox[] = [];

  activeUser = getActiveUser();

  myMessagesItems: CockpitEntryInfo[] = [];
  projectManagement = getProjectManagement();

  hasSharedEmailAddressChanged = false;

  retrievedClientPanels: ClientPanel[] = [];
  retrieveDeviceOverviews: DeviceOverview[] = [];

  isLoading = false;

  get roleSettings() {
    return RoleSettingsModule.roleSettings;
  }

  get isAllowedToViewHyDryDevicesOfMemberClients() {
    const activeUser = this.targetUser;

    return viewHyDryDevicesOfMemberAccess(activeUser);
  }

  get isCachedAdministratorClientUser() {
    return ClientModule.isAdministratorClientUser;
  }

  get memberClientIds() {
    if (this.isCachedAdministratorClientUser) {
      return ClientModule.memberClientIds;
    }

    return getMemberClientIds();
  }

  get isAdministratorClientUser() {
    return switchClientsAccess() || this.isCachedAdministratorClientUser;
  }

  get hyDryMessagesSettings() {
    return getHyDryMessagesSettings();
  }

  /**
   * Disposes the per-target-user subscriptions and forgets them.
   *
   * Emptying the array is the point: the callers used to dispose the entries and then
   * push new ones onto the same array, so it grew for the life of the screen and every
   * re-subscribe disposed the already-disposed entries again instead of the live ones.
   * Each device observer keeps its own merged device set, so two live observers write
   * the device list in turn - which is why the cockpit's counters visibly dropped back
   * and climbed again while loading.
   */
  releaseTargetUserSubscriptions() {
    this.targetUserSubscriptions.forEach((subscription) => subscription());
    this.targetUserSubscriptions = [];
  }

  @Watch("roleSettings", { immediate: true })
  onRoleSettingsChanged() {
    this.cockpitInfoCache = null;
    this.releaseTargetUserSubscriptions();

    if (!getClientId()) return;

    this.observeIresDevicesOfUser(this.targetUser);
    this.observeMailboxesOfUser(this.targetUser);
  }

  @Watch("recentlyFinishedLeakDetectionProjects", { immediate: true })
  onRecentlyFinishedLeakDetectionProjectsChanged() {
    this.skipCockpitInfoCache = true;
  }

  @Watch("recentlyFinishedDryingProjects", { immediate: true })
  onRecentlyFinishedDryingProjectsChanged() {
    this.skipCockpitInfoCache = true;
  }

  @Watch("runningDryingProjects", { immediate: true })
  onRunningDryingProjectsChanged() {
    this.skipCockpitInfoCache = true;
  }

  @Watch("runningLeakDetectionProjects", { immediate: true })
  onRunningLeakDetectionProjectsChanged() {
    this.skipCockpitInfoCache = true;
  }

  @Watch("targetUser", { immediate: true })
  onTargetUserChanged(newTargetUser: User | null) {
    if (!newTargetUser) {
      return;
    }
    this.cockpitInfoCache = null;

    this.releaseTargetUserSubscriptions();

    this.observeIresDevicesOfUser(newTargetUser);
    this.observeMailboxesOfUser(newTargetUser);
  }

  @Watch("hasSharedEmailAddressChanged")
  onSharedEmailAddressChanged(hasChanged: boolean) {
    if (hasChanged) {
      this.setSwitchSharedUserIcon();
    }
  }

  async setSwitchSharedUserIcon() {
    const user = getActiveUser();
    const sharedEmailAddressId = user?.sharedEmailAddressId;

    this.activeUser = user;

    if (sharedEmailAddressId) {
      this.showSharedUserSelector = true;
      const sharedEmailAddressInfo = await getSharedEmailAddressInfo(sharedEmailAddressId);
  
      if (Object.keys(sharedEmailAddressInfo?.userInfo).length < 2) {
        this.hideSwitchSharedUser = true;
      }
      else {
        this.hideSwitchSharedUser = false;
      }
    }
    else {
      this.showSharedUserSelector = false;
    }

    this.hasSharedEmailAddressChanged = false;
  }

  @Watch("selectedBranchFilter")
  onBranchFilterChanged(newBranchFilter: BranchFilter) {
    this.skipCockpitInfoCache = true;
    this.selectedBranchFilter = newBranchFilter;
  }

  get showMessages() {
    return myMessagesTileAccess(this.targetUser);
  }

  get targetUser() {
    return getViewAsUser() ?? this.activeUser;
  }

  showSharedUserSelector = this.activeUser && this.hasSharedEmailAddress(this.activeUser);

  get showSharedUserOfGroupIcon() {
    const activeUser = this.activeUser;

    return activeUser?.sharedUserOfGroup
  }

  /** Users the "Sicht auf" picker can offer, excluding the session user. */
  get selectableTargetUsers() {
    return getSelectableTargetUsers(UserModule.users, this.activeUser);
  }

  /**
   * Like the branch selector, the "Sicht auf" icon is hidden when there is
   * nothing to pick. It stays visible while a target user is selected, since
   * then it is the only way back to the own view.
   */
  get showTargetUserSelector() {
    const user = this.activeUser;

    if (!user) {
      return false;
    }

    if (!this.hasPermissionForUserPicker(user)) {
      return false;
    }

    return this.hasSelectedTargetUser || this.selectableTargetUsers.length > 0;
  }

  hasSharedEmailAddress(user: User) {
    if (!user) {
      return false;
    }

    if (user.sharedEmailAddressId) {
      return true;
    }

    return false;
  }

  hasPermissionForUserPicker(user: User) {
    return switchTargetUserAccess(user);
  }

  get mailboxFilter() {
    return new MailboxFilter(
      this.mailboxes,
      this.userLookup,
      this.selectedBranchFilter,
      [...this.panels, ...this.comBoxes],
      this.hyDryMessagesSettings
    );
  }

  get hyDryEventMessagesFilter() {
    const targetUser = this.targetUser;

    if (!targetUser) {
      return null;
    }

    return HyDryEventMessagesFilter.createFilterFromSettings(
      targetUser,
      this.selectedBranchFilter,
      [...this.panels, ...this.comBoxes],
      this.hyDryMessagesSettings
    );
  }

  get hasSelectedTargetUser() {
    return this.targetUser && this.targetUser?.id !== this.activeUser?.id;
  }

  get switchClientIcon() {
    return "mdi-domain-switch";
  }

  get sharedUserIcon() {
    return "mdi-account";
  }

  get targetUserIcon() {
    return "mdi-eye";
  }

  get selectIconStyle() {
    return this.isCachedAdministratorClientUser
      ? `background-color: ${COLOR_SELECTED_NON_DEFAULT_TOOLBAR_FILTER_BACKGROUND}`
      : "";
  }

  get targetUserIconStyle() {
    return this.hasSelectedTargetUser
      ? `background-color: ${COLOR_SELECTED_NON_DEFAULT_TOOLBAR_FILTER_BACKGROUND}`
      : "";
  }

  get clientTooltip() {
    return this.$t("cockpit.iresExtra.selectClient");
  }

  get sharedUserTooltip() {
    return this.$t("cockpit.iresExtra.selectSharedUser");
  }

  get targetUserTooltip() {
    return this.hasSelectedTargetUser
      ? this.$t("cockpit.iresExtra.backToUser", [
          this.activeUser?.nickname ?? "",
        ]).toString()
      : this.$t("cockpit.iresExtra.selectUser").toString();
  }

  get noOtherTilesVisible() {
    const {
      showAppointmentManagement,
      showRelevantProjectsTile,
      showProjectOrganisationTile,
      showAllProjects,
      showAllHyDryDevices,
      showAllDevices,
      showMyProjects,
      showMyHyDryDevices,
      showMyAppointments
    } = this.tileAccessInfo;

    return !( 
      this.showMessages ||
      showProjectOrganisationTile ||
      (showAppointmentManagement && this.cockpitInfo.appointmentManagementItems.length > 0) ||
      (showRelevantProjectsTile && this.cockpitInfo.relevantProjects.length > 0) ||
      (showMyAppointments && this.cockpitInfo.myAppointmentItems.length > 0) ||
      (showMyProjects && this.cockpitInfo.myProjectItems.length > 0) ||
      (showMyHyDryDevices && this.myHyDryDevicesItems.length > 0) ||
      (showAllProjects && this.cockpitInfo.allProjectPhaseItems.length > 0) ||
      (showAllHyDryDevices && this.allHyDryDevicesItems.length > 0) ||
      (showAllDevices && this.allDevicesItems.length > 0) ||
      this.cockpitInfo.projectsNoApp.length > 0
    );
  }

  get tileAccessInfo() {
    const tileAccessResults = {
      showAppointmentManagement: appointmentManagementTileAccess(this.targetUser),
      showRelevantProjectsTile: relevantProjectsTileAccess(this.targetUser),
      showProjectOrganisationTile: projectOraganisationTileAccess(this.targetUser),
      showAllProjects: allProjectsTileAccess(this.targetUser),
      showAllHyDryDevices: allHyDryDevicesAccess(this.targetUser),
      showAllDevices: allDevicesTileAccess(this.targetUser),
      showMyProjects: myProjectsTileAccess(this.targetUser),
      showMyHyDryDevices: myHyDryDevicesTileAccess(this.targetUser),
      showMyAppointments: myAppointmentsTileAccess(this.targetUser),
      showAllIresDevicesAndProjects: allHyDryDevicesAccess(this.targetUser)
    };
    
    return tileAccessResults;
  }

  get hyDryDevicesTitle() {
    return this.$t(
      this.tileAccessInfo.showAllIresDevicesAndProjects
        ? "cockpit.allHyDryDevices"
        : "cockpit.myHyDryDevices"
    );
  }

  get hyDryDevicesBackgroundColor() {
    return this.tileAccessInfo.showAllIresDevicesAndProjects
      ? this.colorExtras
      : this.colorMyTasks;
  }

  get clientName() {
    const clientInfo = this.clientInfo;

    if (!clientInfo) {
      return null;
    }

    const clientName =
      !clientInfo.companyName || clientInfo.companyName === ""
        ? clientInfo.clientName
        : clientInfo.companyName;

    if (clientName) {
      return this.$t("cockpit.formatCompany", [clientName]).toString();
    } else {
      return null;
    }
  }

  get branchText() {
    const branchFilter = this.selectedBranchFilter;

    const branchName = branchFilter.branch
      ? getBranchName(branchFilter.branch)
      : this.$t("common.all");

    return this.$t("clientData.formatBranch", [branchName]).toString();
  }

  get signedInAsText() {
    const activeUser = UserModule.activeUser;
    const userName = activeUser ? getUserDisplayName(activeUser) : "Master";

    return this.$t("common.signedInAs", [userName]).toString();
  }

  get recentlyFinishedLeakDetectionProjects() {
    return ProjectsModule.recentlyFinishedLeakDetectionProjects;
  }

  get recentlyFinishedDryingProjects() {
    return ProjectsModule.recentlyFinishedDryingProjects;
  }

  get runningDryingProjects() {
    return ProjectsModule.runningDryingProjects;
  }

  get runningLeakDetectionProjects() {
    return ProjectsModule.runningLeakDetectionProjects;
  }

  cockpitInfoCache: CockpitProjectsInfo | null = null;
  cockpitInfoDebounceTimeout: Date | null = null;
  debounceTimeout: NodeJS.Timeout | null = null;
  skipCockpitInfoCache = false;

  get projectManagementSettings() {
    return ProjectManagementSettingsModule.projectManagementSettings;
  }

  get projectSettings() {
    return getProjectSettingsV2(this.projectManagementSettings);
  }

  get cockpitInfo(): CockpitProjectsInfo {
    if (this.debounceTimeout) {
      clearTimeout(this.debounceTimeout);
    }

    if (this.cockpitInfoCache && !this.skipCockpitInfoCache) {
      return this.cockpitInfoCache;
    }

    this.debounceTimeout = setTimeout(() => {
      try {
        const targetUser = this.targetUser;
        const activeUser = this.activeUser;
        const userLookup = this.userLookup;

        if (targetUser && activeUser && userLookup) {
          const isAllowedToViewAllProjects = this.tileAccessInfo.showAllProjects;
          const isAllowedToViewRelevantProjects = this.tileAccessInfo.showRelevantProjectsTile;
          const isAllowedToCreateProject = createProjectAccess(targetUser, this.projectSettings);
          const isAllowedToCreateAppointment = createAppointmentAccess(targetUser, this.projectSettings);

          const recentDryingProjects = [
            ...this.runningDryingProjects,
            ...this.recentlyFinishedDryingProjects,
          ];

          const recentLeakDetectionProjects = [
            ...this.runningLeakDetectionProjects,
            ...this.recentlyFinishedLeakDetectionProjects,
          ];

          const cockpitProjectInfo = createCockpitProjectInfo(
            {
              recentDryingProjects: recentDryingProjects,
              recentLeakDetectionProjects: recentLeakDetectionProjects,
            },
            {
              userLookup,
              targetUser,

              branchFilter: this.selectedBranchFilter,
              vue: this,

              addAllProjects: isAllowedToViewAllProjects,
              addRelevantProjects: isAllowedToViewRelevantProjects,
              addAppointmentItems: isAllowedToCreateAppointment,

              doesClientHaveApp: doesClientHaveApp(),

              createProject: isAllowedToCreateProject,
            }
          );

          this.cockpitInfoCache = cockpitProjectInfo;
          this.skipCockpitInfoCache = false;
        }
      } catch (error) {
        // Error
      }
    }, 1500);

    return this.cockpitInfoCache ?? {
      allProjectPhaseItems: [],
      projectsNoApp: [],
      myAppointmentItems: [],
      projectOrganisationItems: [],
      appointmentManagementItems: [],
      myProjectItems: [],
      relevantProjects: [],
    };
  }

  get allHyDryDevicesItems() {
    return this.getHyDryDeviceItems(true);
  }

  get myHyDryDevicesItems() {
    return this.getHyDryDeviceItems(false);
  }

  get allDevicesItems() {
    return this.getAllDeviceItems();
  }

  get deviceOverviews() {
    return this.retrieveDeviceOverviews;
  }

  get clientPanels() {
    return this.retrievedClientPanels;
  }

  getHyDryDeviceItems(showAllDevices: boolean) {
    const iresDevices = [...this.panels, ...this.comBoxes];

    if (iresDevices.length === 0) {
      return [];
    }

    // A Set, not an array: this is checked once per device, and a master client has
    // ~1000 of them.
    const deletedSerialNumbers = new Set(
      this.clientPanels
        .filter((panel) => isDeviceDeleted(panel))
        .map((panel) => panel.serialNumber)
    );

    const retainedIresDevices = iresDevices.filter(
      (device) => !deletedSerialNumbers.has(device.serialNo)
    );

    if (retainedIresDevices.length === 0) {
      return [];
    }

    return calculateHyDryDeviceItems(showAllDevices, retainedIresDevices, {
      vue: this,
      targetUser: this.targetUser,
      branchFilter: this.selectedBranchFilter,
    });
  }

  getAllDeviceItems() {
    const allDevices = [
      ...this.deviceOverviews,
      ...this.clientPanels
    ];

    if (allDevices.length === 0) {
      return [];
    }

    // To match the number of IRES devices in usage. Read through the computed rather than
    // recounting (counting every device against every filter is the most expensive thing
    // the cockpit does), and selected by the filter it counts rather than by position: a
    // counter of zero adds no tile at all, so index 0 was the in-usage count only while
    // at least one device was in usage, and the active count otherwise.
    const clientPanelsInUsage = getHyDryDeviceCount(
      this.allHyDryDevicesItems,
      DeviceFilter.IN_USAGE
    );

    return calculateAllDevicesItems(
      filterRetainedDevices(allDevices), 
      {
        vue: this,
        branchFilter: this.selectedBranchFilter,
      },
      clientPanelsInUsage
    );
  }

  get showComBoxInfo() {
    return false;
  }

  get clientAddress() {
    const clientInfo = this.clientInfo;

    if (!clientInfo) {
      return "";
    }

    return formatLocationInfo(clientInfo);
  }

  get showLogo() {
    return !!this.logo;
  }

  get recentlyFinishedProjectsThreshold() {
    return FinishedProjectsSettingsModule.finishedProjectsSettings.recentlyFinishedProjects;
  }
  
  get users() {
    return UserModule.users;
  }

  get userLookup() {
    return new UserLookup(this.users);
  }

  openProjects() {
    router.push({ path: "/main/cockpit/projects" });
  }

  openDevices() {
    router.push({ path: "/main/devices" });
  }

  openDeviceDetails(serialNumber: string) {
    router.push({
      path: `/main/devices/${serialNumber}`,
    });
  }

  async created() {
    this.isLoading = true;
    //Delay to fix lag when screen gets first shown. TODO find out what causes lag.
    await new Promise((resolve) => setTimeout(resolve, 500));

    this.setSwitchSharedUserIcon();

    this.subscriptions.push(observeRunningDryingProjects());
    this.subscriptions.push(observeRecentlyFinishedDryingProjects(this.recentlyFinishedProjectsThreshold));
    this.subscriptions.push(observeRunningLeakDetectionProjects());
    this.subscriptions.push(observeRecentlyFinishedLeakDetectionProjects(this.recentlyFinishedProjectsThreshold));
    this.subscriptions.push(observeDeviceOverviews(
      (deviceOverview: Array<DeviceOverview>) => {
        this.retrieveDeviceOverviews = deviceOverview;
      }
    ));
    this.subscriptions.push(observeClientPanels(
      (clientPanels: Array<ClientPanel>) => {
        this.retrievedClientPanels = clientPanels;
      }
    ));

    this.isLoading = false;
  }

  activated() {
    const shouldReloadClientPanels = localStorage.getItem("shouldReloadClientPanelsForCockpit");
    if (shouldReloadClientPanels === "true") {
      // An explicit request to re-read, so it forces past the scope guard.
      this.observeIresDevicesOfUser(this.targetUser, true);

      localStorage.setItem("shouldReloadClientPanelsForCockpit", "false");
    }

    const branchIdQuery = getStoredBranchFilterId("branchFilter");
    
    const currentUser = getActiveUser();
    const activeUser = this.activeUser;

    if (currentUser?.sharedEmailAddressId !== activeUser?.sharedEmailAddressId) {
      this.hasSharedEmailAddressChanged = true;
    }
    else {
      this.hasSharedEmailAddressChanged = false;
    }

    if (branchIdQuery) {
      const matchingBranch = findBranch(branchIdQuery);

      if (matchingBranch) {
        this.selectedBranchFilter = new BranchFilter(
          hasClientEnabledStrictBranchFilters(),
          matchingBranch
        );
      }
    }
    else {
      this.selectedBranchFilter = getDefaultBranchFilterOfUser();
    }
    
    this.componentActive = true;
  }

  deactivated() {
    this.componentActive = false;
  }

  mounted() {
    this.componentActive = true;
    this.calculateVisibility();
    window.addEventListener("resize", this.calculateVisibility);
  }

  beforeDestroy() {
    window.removeEventListener("resize", this.calculateVisibility);
    this.subscriptions.forEach((subscription) => subscription());
    this.releaseTargetUserSubscriptions();
    this.releaseIresDeviceSubscriptions();
    this.clearIresDeviceUpdateDebouncer();
  }

  observeMailboxesOfUser(user: User | null) {
    if (!user) {
      return;
    }

    this.targetUserSubscriptions.push(
      observeMailboxesOfUser(user.id, (mailboxes: Mailbox[]) => {
        this.mailboxes = mailboxes;
      })
    );
  }

  /**
   * Subscribes to the devices the tiles count, unless that subscription is already in
   * place for exactly this scope.
   *
   * The guard is what stops the counters resetting. `targetUser` derives from the
   * `activeUser` field, which is reassigned with a fresh `getActiveUser()` object (a
   * `JSON.parse`, so a new identity every time) whenever the shared-user icon is
   * refreshed. The watcher on it therefore fires for the *same* user, and every
   * re-subscribe replaces observers that had already accumulated the full device set
   * with fresh ones that start empty - so the counts dropped back and climbed again,
   * mid-load, for no reason at all.
   *
   * Only the query inputs are compared: who the devices are read for, and whether they
   * are read across the member clients or for the signed-in client alone.
   */
  observeIresDevicesOfUser(user: User | null, forceResubscribe = false) {
    const userId = this.tileAccessInfo.showAllIresDevicesAndProjects ? null : user?.id;
    const isMemberScope = this.isAllowedToViewHyDryDevicesOfMemberClients;
    const scopeKey = `${isMemberScope}:${userId ?? ""}`;

    const isAlreadyObserved =
      this.iresDeviceSubscriptions.length > 0 &&
      scopeKey === this.observedIresDeviceScopeKey;

    if (isAlreadyObserved && !forceResubscribe) {
      return;
    }

    this.releaseIresDeviceSubscriptions();
    this.observedIresDeviceScopeKey = scopeKey;

    this.iresDeviceSubscriptions.push(isMemberScope
      ? observePanelsOfMemberClients((panels: Array<Panel>) => {
          this.debounceIresDeviceUpdate(() => (this.panels = panels));
        })
      : observePanelsOfClient(userId, (panels: Array<Panel>) => {
          this.debounceIresDeviceUpdate(() => (this.panels = panels));
        })
    );

    this.iresDeviceSubscriptions.push(isMemberScope
      ? observeComBoxesOfMemberClients((comBoxes: Array<ComBox>) => {
          this.debounceIresDeviceUpdate(() => (this.comBoxes = comBoxes));
        })
      : observeComBoxesOfClient(userId, (comBoxes: Array<ComBox>) => {
          this.debounceIresDeviceUpdate(() => (this.comBoxes = comBoxes));
        })
    );
  }

  /**
   * Device subscriptions are kept apart from the other per-target-user ones so that
   * re-subscribing the mailboxes does not tear down the device observers, and with them
   * the accumulated device set the counters are derived from.
   */
  releaseIresDeviceSubscriptions() {
    this.iresDeviceSubscriptions.forEach((subscription) => subscription());
    this.iresDeviceSubscriptions = [];
    this.observedIresDeviceScopeKey = null;

    // A released observer can still have a coalesced update queued, and its closure
    // holds that observer's device set. Applying it after the replacement observers
    // have started would drop the counts back to a stale value.
    this.clearIresDeviceUpdateDebouncer();
  }

  /**
   * Coalesces device snapshots before they reach the counters.
   *
   * For a member-client view these two observers open one Firestore listener per
   * member client and each callback delivers the full device set, so a master client
   * gets dozens of callbacks in a burst during load and recounts every device against
   * every filter for each of them. The device list already coalesces the same
   * snapshots with the same 100 ms window.
   *
   * Each pending update keeps its own assignment, so a panel snapshot cannot discard
   * a ComBox snapshot that arrived in the same window.
   */
  debounceIresDeviceUpdate(applyUpdate: () => void) {
    this.pendingIresDeviceUpdates.push(applyUpdate);

    if (this.iresDeviceUpdateDebouncer) {
      clearTimeout(this.iresDeviceUpdateDebouncer);
    }

    this.iresDeviceUpdateDebouncer = setTimeout(() => {
      this.iresDeviceUpdateDebouncer = null;

      const updates = this.pendingIresDeviceUpdates;
      this.pendingIresDeviceUpdates = [];

      updates.forEach((update) => update());
    }, 100);
  }

  clearIresDeviceUpdateDebouncer() {
    if (this.iresDeviceUpdateDebouncer) {
      clearTimeout(this.iresDeviceUpdateDebouncer);
      this.iresDeviceUpdateDebouncer = null;
    }

    this.pendingIresDeviceUpdates = [];
  }

  get isAllowedToViewClientSelector() {
    return viewClientSelectorAccess(this.activeUser);
  }

  async onSwitchClient() {
    const activeUser = this.activeUser;
    const clients = activeUser?.clients;
    const emailAddress = activeUser?.emailAddress;
    const userId = activeUser?.id;

    const memberClientIds = this.memberClientIds;

    if (!memberClientIds || memberClientIds.length === 0) {
      return;
    }

    const memberClients = await getClientsByIds(memberClientIds);
    // #2610066: a blocked or deleted member cannot be switched to, so it is not offered.
    memberClients.forEach((client, clientId) => {
      if (isClientSignInBlocked(client)) {
        memberClients.delete(clientId);
      }
    });

    const result = await this.clientOptionsDialog.show(
      memberClients,
      true,
      clients,
      emailAddress,
      userId,
    );

    return result;
  }

  async onSwitchSharedUserOfGroup() {
    const activeUser = this.activeUser;
    const clients = activeUser?.clients;
    const emailAddress = activeUser?.emailAddress;
    const userId = activeUser?.id;

    if (
      !userId || 
      !emailAddress ||
      !clients || 
      clients.length === 0
      ) {
      return;
    }

    // #2610066: a blocked member cannot be switched to, so it is not offered (deleted ones are already gone).
    const clientsInfoOfGroup = await getMemberClientsInformationOfGroup(clients);
    clientsInfoOfGroup.forEach((client, clientId) => {
      if (client.blocked === true) {
        clientsInfoOfGroup.delete(clientId);
      }
    });

    const result = await this.sharedUserOfGroupOptionsDialog.show(
      userId,
      emailAddress,
      clientsInfoOfGroup,
      true
    );

    return result;
  }

  async onSwitchUserWithSharedEmailAddress(sharedEmailAddressId: string) {
    const sharedEmailAddressInfo = await getSharedEmailAddressInfo(
      sharedEmailAddressId
    );

    if (!sharedEmailAddressInfo) {
      return;
    }

    const sharedEmailAddressUserOptions = [];

    for (const key of Object.keys(sharedEmailAddressInfo.userInfo)) {
      const userInfo = sharedEmailAddressInfo.userInfo[
        key
      ] as SharedEmailAddressUserInfo;

      if (userInfo) {
        sharedEmailAddressUserOptions.push(userInfo);
      }
    }
    
    const password = UserModule.sharedUserPassword;

    const result = await this.sharedEmailAddressOptions.show(
      sharedEmailAddressInfo,
      sharedEmailAddressUserOptions,
      password,
      true
    );

    return result;
  }

  async onSelectClient() {
    if (!this.isAdministratorClientUser) {
      return;
    }

    const loginResult = await this.onSwitchClient();
    if (loginResult === LoginResult.SUCCESS) {
      await this.onSuccessfulSwitch();
    }
  }

  async onSelectSharedUser() {
    const user = this.activeUser;

    if (!user || !user.sharedEmailAddressId) {
      return;
    }

    const loginResult = await this.onSwitchUserWithSharedEmailAddress(
      user.sharedEmailAddressId
    );

    if (loginResult === LoginResult.SUCCESS) {
      await this.onSuccessfulSwitch();
    } 
  }

  async onSelectSharedUserOfGroup() {
    const user = this.activeUser;

    if (!user || !user.sharedUserOfGroup) {
      return;
    }

    const loginResult = await this.onSwitchSharedUserOfGroup();
    if (loginResult === LoginResult.SUCCESS) {
      await this.onSuccessfulSwitch();
    } 
  }

  async onSuccessfulSwitch() {
    // A client, shared user or group switch ends "Sicht auf"; session storage survives the reload.
    clearViewAsSelection();
    await loadClient();
    window.location.reload();
  }

  async onToggleTargetUser() {
    if (this.hasSelectedTargetUser) {
      endViewAs();
    } else {
      await this.onPickTargetUser();
    }
  }

  async onPickTargetUser() {
    const selectedUser = await this.userPickerDialog.show(
      this.selectableTargetUsers
    );

    if (selectedUser && this.targetUser?.id != selectedUser.id) {
      startViewAs(selectedUser);
    }
  }

  calculateVisibility() {
    this.$nextTick(() => {
      const toolbarMenu = this.$refs.toolbarMenu as HTMLElement;

      if (toolbarMenu) {
        localStorage.setItem("toolbarMenuWidth", toolbarMenu.offsetWidth.toString());
      }
    });
  }
}
